import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'next-themes';
import './index.css';
import { queryClient } from './lib/api';
import { SessionProvider } from './lib/auth';
import { I18nProvider } from './lib/i18n';
import { Toaster } from './components/ui/sonner';
import { App } from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false} disableTransitionOnChange>
      <QueryClientProvider client={queryClient}>
        <I18nProvider>
          <SessionProvider>
            <App />
            <Toaster />
          </SessionProvider>
        </I18nProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
